import { useQuery } from '@tanstack/react-query';
import { StatusCode, REACT_QUERY_KEYS } from '@hungryroot/rest';
import {
  getCustomer,
  CustomerIncludes,
} from '@hungryroot/rest/api/get_customer/get';
export {
  type Customer,
  type CustomerIncludesAll,
  CustomerIncludes,
} from '../../api/get_customer/get/get_customer';

interface RequestOptions {
  enabled?: boolean;
}

export function useCustomer(options: RequestOptions = {}) {
  return useQuery({
    queryKey: [REACT_QUERY_KEYS.CUSTOMERS, { includes: CustomerIncludes.All }],
    queryFn: async () => {
      const res = await getCustomer({ includes: [CustomerIncludes.All] });

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(`${res.data}`);
      }
      return res.data;
    },
    ...options,
  });
}
